import { render } from "./InputForm.vue?vue&type=template&id=5f982834&scoped=true"
import script from "./InputForm.vue?vue&type=script&lang=js"
export * from "./InputForm.vue?vue&type=script&lang=js"

import "./InputForm.vue?vue&type=style&index=0&id=5f982834&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f982834"]])

export default __exports__